import { hydrate } from "../hydrate.tsx";
import { Header, type HeaderProps } from "./Header.tsx";

hydrate<HeaderProps>("header-island", (props) => <Header {...props} />);
